import WebSocket from "../config/ws";
import Utils from "../Utils";
import "moment/min/locales";
import moment from "moment";

export const actions = {
    AUTH_USER: 'AUTH_USER',
    UNAUTH_USER: 'UNAUTH_USER',
    SET_TENANT: 'SET_TENANT',
    SET_ROLES: "SET_ROLES",
    SET_UI_ROUTES: 'SET_UI_ROUTES',
    SET_APPLICATION_LOCALE: "SET_APPLICATION_LOCALE"
};

interface IAuth {
    user: any
    tenant: any,
    uiRoutes: any,
    roles: []
}

export default (state = {
    user: null,
    tenant: null,
    groups: {},
    locales: moment.locales(),
    locale: getApplicationLocale(),
    uiRoutes: [],
}, action) => {

    state = {...state};

    switch (action.type) {
        case actions.AUTH_USER: {
            state.user = action.payload;
            WebSocket.open();
            return state;
        }
        case actions.UNAUTH_USER:
            state.user = null;
            WebSocket.close();
            return state;
        case actions.SET_TENANT:
            state.tenant = action.payload;
            return state;
        case actions.SET_ROLES:
            state.groups = action.payload;
            return state;
        case actions.SET_UI_ROUTES:
            state.uiRoutes = action.payload;
            return state;
        case actions.SET_APPLICATION_LOCALE:
            state.locale = action.payload;
            window.localStorage.setItem(Utils.LOCAL_STORAGE_ITEM_LOCALE, JSON.stringify(action.payload));
            window.location.reload();
            return state;
        default:
            return state
    }
};

export function getApplicationLocale(): { label: string, value: string } {
    try {
        const locale: { label: string, value: string } = JSON.parse(window.localStorage.getItem(Utils.LOCAL_STORAGE_ITEM_LOCALE) as string);
        if (!locale) {
            return setLocaleToLocalStorage();
        }
        return locale;
    } catch (e) {
        return setLocaleToLocalStorage();
    }

    function setLocaleToLocalStorage(): { label: string, value: string } {
        const localeTag = moment.locale();
        const localeOption = {
            label: Utils.getLocaleNameByTag(localeTag),
            value: localeTag
        };
        window.localStorage.setItem(Utils.LOCAL_STORAGE_ITEM_LOCALE, JSON.stringify(localeOption));
        return localeOption;
    }
}



// WEBPACK FOOTER //
// ./app/reducers/auth.ts